var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 1.375C4.25 0.96 4.585 0.625 5 0.625C5.415 0.625 5.75 0.96 5.75 1.375V1.96C7.32 2.3 8.5 3.7 8.5 5.375V8.375L9.5 9.375V9.875H0.5V9.375L1.5 8.375V5.375C1.5 3.7 2.68 2.3 4.25 1.96V1.375ZM5 2.875C6.38 2.875 7.5 3.995 7.5 5.375V8.875H2.5V5.375C2.5 3.995 3.62 2.875 5 2.875ZM4.00512 10.3801C4.00512 10.9301 4.45012 11.3751 5.00012 11.3751C5.55012 11.3751 5.99512 10.9301 5.99512 10.3801H4.00512Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ab005c95bfc2321d6d7c42798a8f50d4.svg";
export { ForwardRef as ReactComponent };